import gsap from 'gsap';
import { getCurrentDevice } from '../utils';

export class SliderControls {
	constructor( selector, options = {} ) {
		this.elements = document.querySelectorAll( selector );
		this.devices = options.devices || [ 'Desktop', 'Tablet', 'Mobile' ];
		this.currentDevice = getCurrentDevice();
		this.isExecuted = false;
		this.timer = null;
		this.theTimelines = [];
		this.theParents = [];
		this.enterFuncs = [];
		this.leaveFuncs = [];
		this.init();
	}

	init() {
		if ( this._initBound ) return;
		this._initBound = true;
		if ( ! this.elements?.length ) return;
		if ( this.devices.includes( this.currentDevice ) ) {
			this.execute();
		}
		this.resize();
	}

	execute() {
		this.elements.forEach( ( container, index ) => {
			// 设置动画
			gsap.set( container, { opacity: 0, display: 'none' } );
			const tl = gsap.timeline( { paused: true } );
			tl.to( container, { opacity: 1, display: 'flex' } );
			this.theTimelines[ index ] = tl;
			// 设置事件
			const theParentSlider = container.parentNode;
			this.theParents[ index ] = theParentSlider;
			this.enterFuncs[ index ] = () => {
				this.enter( index );
			};
			this.leaveFuncs[ index ] = () => {
				this.leave( index );
			};
			this.theParents[ index ].addEventListener(
				'mouseenter',
				this.enterFuncs[ index ]
			);
			this.theParents[ index ].addEventListener(
				'mouseleave',
				this.leaveFuncs[ index ]
			);
		} );
		this.isExecuted = true;
	}

	destroy() {
		this.theTimelines.forEach( ( timeline ) => {
			timeline.timeline?.kill();
		} );
		this.elements.forEach( ( container, index ) => {
			gsap.set( container, { clearProps: 'opacity,display' } );
			if ( this.enterFuncs[ index ] ) {
				this.theParents[ index ].removeEventListener(
					'mouseenter',
					this.enterFuncs[ index ]
				);
			}
			if ( this.leaveFuncs[ index ] ) {
				this.theParents[ index ].removeEventListener(
					'mouseleave',
					this.leaveFuncs[ index ]
				);
			}
		} );
		this.theTimelines = [];
		this.theParents = [];
		this.enterFuncs = [];
		this.leaveFuncs = [];
		this.isExecuted = false;
	}

	resize() {
		window.addEventListener( 'resize', () => {
			this.timer?.kill();
			this.timer = gsap.delayedCall( 0.5, () => {
				const prevDevice = this.currentDevice;
				this.currentDevice = getCurrentDevice();
				if ( prevDevice !== this.currentDevice ) {
					if ( this.isExecuted ) {
						this.destroy();
					}
					if ( this.devices.includes( this.currentDevice ) ) {
						this.execute();
					}
				}
			} );
		} );
	}

	enter( index ) {
		this.theTimelines[ index ]?.play();
	}

	leave( index ) {
		this.theTimelines[ index ]?.reverse();
	}
}
